import { render, staticRenderFns } from "./CampagnaList.vue?vue&type=template&id=deb72eb0&"
import script from "./CampagnaList.vue?vue&type=script&lang=ts&"
export * from "./CampagnaList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports